export const colors = {
  main_color: "#cf3aa0",
  main_color_bg: "#cf3aa022",
  orange: "#FCBC00",
  orange_bg: "#fffcf5",
  red: "#EB255D",
  red_bg: "#FEF4F7",
  green: "#0FB682",
  green_bg: "#F3FBF9",
  border_color: "#d6dae0",
  //
  advert: "#cf3aa0",
  // advert: "#1834d1",
};

//Цвета изменений
export const changeColors = {
  negative: "#EB255D",
  bgNegative: "#FEF4F7",
  positive: "#0FB682",
  bgPositive: "#F3FBF9",
  neutral: "#FCBC00",
  bgNeutral: "#FFF7E1",
};
